import axios from "axios"
import axiosUserAuthRequired from "@/api/axiosAuthRequired.js"
import { isEmpty } from "lodash"
import { BASE_URL } from "@/constants/util"
import { getAuthHeaders } from "@/api/auth"

export const fetchClientCredentialsWithOneTimeToken = async oneTimeToken => {
  try {
    const url = `${BASE_URL}tokens`
    const body = new FormData()

    body.append("grant_type", "one_time_token")
    body.append("one_time_token", oneTimeToken)

    const res = await axios.post(url, body)
    return res.data
  } catch (error) {
    console.error(error)
    return Promise.reject(error)
  }
}

export const syncServerLoginState = async () => {
  const authHeaders = getAuthHeaders()
  if (isEmpty(authHeaders)) {
    return
  }

  try {
    const url = `${process.env.PROGUIDES_WEB_URL}functions/user/sync-login-state`
    const config = {
      headers: authHeaders,
    }
    axiosUserAuthRequired.post(url, null, config)
  } catch (e) {
    console.error("Failed to sync login state", e)
    return Promise.reject(e)
  }
}

export const refreshAimlabsToken = async () => {
  try {
    const url = `${BASE_URL}user/account/oauth-providers/aimlabs/refresh_token`
    const config = {
      headers: getAuthHeaders(),
    }
    await axiosUserAuthRequired.post(url, null, config)
  } catch (e) {
    console.error("Failed to refresh token", e)
    return Promise.reject(e)
  }
}



// WEBPACK FOOTER //
// ./src/store/auth/auth.apis.js